const videoContextFactory = (): __WebpackModuleApi.RequireContext => {
  return require.context('@/assets', true, /\.(mp4|webm)$/i);
};

export const videoContext = videoContextFactory();
